import { Toaster } from 'react-hot-toast';

const ToastProvider = () => (
    <Toaster
        toastOptions={{
            style: {
                background: 'transparent',
                padding: 0,
                boxShadow: 'none',
            },
        }}
    />
);

export { ToastProvider };
